export const pickFromHash = (hash: string): string => {
  // Matches the first path segment after a hash or ampersand,
  //   stripping any trailing non-word characters or hyphens.
  const match = hash.match(/[#&]\/(%2f)?(.+?)([^\w\d-]|$)/i);
  return match?.[2] || '';
};
